import { connect } from 'react-redux';
import Likes from '../../components/metadata/likes';

import { toggleLiked } from '../../actions/likes';

const mapStateToProps = function(state) {
	return {
		visible: state.features.likes,
		...state.likes,
		allow_like: state.features.like
	};
}

const mapDispatchToProps = function(dispatch) {
	return {
		toggleLiked: ()=>dispatch(toggleLiked())
	};
}

const LikesContainer = connect(
	mapStateToProps,
	mapDispatchToProps,
	undefined,
	{
		pure: true
	}
)(Likes)

export default LikesContainer;